import React from "react";
import { IconType } from "react-icons";
import * as C from "./styles";

interface Props {
  text?: string;
  error?: boolean;
  disabled?: boolean;
  icon?: JSX.Element;
  iconAtEnd?: boolean;
  customStyle?: React.CSSProperties;
  onClick?: (e?: any) => any;
  type?: "button" | "submit" | "reset" | undefined;
  initialBorderColor?: string;
  className?: string;
}

export default function FormButton({
  type,
  initialBorderColor,
  text,
  error,
  disabled,
  icon,
  iconAtEnd,
  customStyle,
  className,
  onClick,
}: Props) {
  return (
    <C.FormButton
      initialBorderColor={initialBorderColor}
      className={className}
      onClick={disabled ? () => {} : onClick}
      style={customStyle}
      type={disabled ? "button" : type}
      role="button"
      disabled={disabled}
      error={error}
    >
      {!iconAtEnd && icon}
      {text?.toUpperCase()}
      {iconAtEnd && icon}
    </C.FormButton>
  );
}
